
<template>
    
        <mars-view><mars-view :style="{
            padding: paddingVertical + ' ' + paddingHorizontal
        }" class="tag-layout"><c-filter-tag-layout-item v-for="(option, optionIndex) in options" :key="optionIndex" :index="optionIndex" :text="option.text" :default-value="option.defaultValue" :type="option.type" :selected-color="primaryColor" :selected-item-bold="selectedItemBold" :selected="selectedIndex === optionIndex || option.selected" :up="selectedIndex === optionIndex" :direction="option.direction" :style="{
                width: 100 / options.length + '%'
            }" @click.native="handleTagLayoutItemTap({
                option,
                optionIndex
            })"></c-filter-tag-layout-item><slot></slot></mars-view><mars-view v-if="borderBottom" class="border"></mars-view></mars-view>
    
</template>

<script>
import FilterTagLayoutItem from "./FilterTagLayoutItem.vue";
export default {
  components: {
    'c-filter-tag-layout-item': FilterTagLayoutItem
  },
  props: {
    /**
     * 选中的项索引
     */
    selectedIndex: {
      type: Number,
      default: -1
    },

    /**
     * 数组
     *
     * @property {string} options[].text 选项的文案
     * @property {string} options[].type 选项的类型；'normal' 普通类型；'order' 排序类型
     */
    options: Array,

    /**
     * 顶部分割线
     */
    borderTop: {
      type: Boolean,
      default: false
    },

    /**
     * 底部分割线
     */
    borderBottom: {
      type: Boolean,
      default: true
    },

    /**
     * 是否阻止 TouchMove 事件
     */
    preventDefaultTouchMove: {
      type: Boolean,
      default: false
    },

    /**
     * 主颜色
     */
    primaryColor: {
      type: String,
      default: '#333'
    },

    /**
     * 选中项是否加粗
     */
    selectedItemBold: {
      type: Boolean,
      default: true
    },

    /**
     * 项选中策略；'default' 默认，只要有 defaultValue 则选中；'strict' 严格，defaultValue 必须到包含最后一列，才选中
     */
    itemSelectStrategy: {
      type: String,
      default: 'default'
    },

    /**
     * 水平 padding
     */
    paddingVertical: {
      type: String,
      default: '10px'
    },

    /**
     * 水平 padding
     */
    paddingHorizontal: {
      type: String,
      default: '17px'
    }
  },

  data() {
    return {};
  },

  created() {
    this.calculateOptionIsSelected(this.options);
  },

  methods: {
    // item 点击
    handleTagLayoutItemTap(obj) {
      obj.lastSelectedIndex = this.selectedIndex;
      this.$emit('taglayouttap', obj);
    },

    // 计算选项是否被选中
    calculateOptionIsSelected(options) {
      for (let i = 0; i < options.length; i++) {
        let option = options[i]; // 默认

        if (this.itemSelectStrategy === 'default' && option.defaultValue) {
          this.$set(this.options[i], 'selected', true);
        } // 严格，仅在级联模式下
        else if (this.itemSelectStrategy === 'strict' && option.defaultValue && option.type === 'list') {
            let defaultValueArray = option.defaultValue.split(','); // 严格模式下，defaultValue 必须到包含最后一列

            if (defaultValueArray.length === option.column) {
              this.$set(this.options[i], 'selected', true);
            } else {
              this.$set(this.options[i], 'selected', false);
            }
          } else {
            this.$set(this.options[i], 'selected', false);
          }
      }
    }

  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        this.calculateOptionIsSelected(newVal);
      },

      deep: true
    }
  }
};
</script>

<style scoped>
.tag-layout-wrapper {
  position: relative;
}
.tag-layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.border {
  border-bottom: 1px solid #eee;
}

</style>
